import { ImageSlide } from '@modules/husleie-framework/src/types/Swiper.entity';

type FileDetail = {
  value: string;
  data: any;
};

export default class CommonConversionOperations {
  private static fileDetailsData: FileDetail[];

  static set fileDetails(apiFileDetails: any) {
    if (apiFileDetails) {
      this.fileDetailsData = Object.entries(apiFileDetails).map((fileDetail: any) => {
        return {
          value: fileDetail[0],
          data: fileDetail[1],
        };
      });
    } else {
      this.fileDetailsData = [];
    }
  }

  static apiImagesToInternal(apiImages: undefined | any): ImageSlide[] {
    if (apiImages && this.fileDetailsData) {
      const returnList: ImageSlide[] = apiImages.map((image: ImageSlide) => {
        const fileDetail: undefined | FileDetail = this.fileDetailsData.find(fd => fd.value === image.token);
        return fileDetail ? { token: image.token, imageSrc: fileDetail?.data?.thumbnails[0]?.url } : null;
      });
      return returnList.filter(entry => !!entry);
    } else {
      return [];
    }
  }

  static internalImagesToApi(images: undefined | ImageSlide[]): undefined | any[] {
    if (images && images.length > 0) {
      return images.map((image: ImageSlide) => {
        return { token: image.token };
      });
    } else {
      return undefined;
    }
  }
}
